import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-verification-details',
  templateUrl: './verification-details.component.html',
  styleUrls: ['./verification-details.component.css'],
  standalone: false
})
export class VerificationDetailsComponent implements OnInit {

  constructor(private apiService: ApiService, private route: ActivatedRoute, private router: Router) {

  }

  details: any;
  errorLoadingDetails: boolean = false;
  searchedDataNotFound: boolean = false;
  qrCodeType: string;
  applicationId: any
  ngOnInit(): void {
    this.applicationId = this.route.snapshot.queryParams['applicationid'];
    this.qrCodeType = this.route.snapshot.queryParams['qrcodetype'];

    this.loadData();
  }

  goBack() {
    
      this.router.navigate(['/login'])
  
  }


  loadData() {
    this.errorLoadingDetails = false;
    this.details = null;
    this.searchedDataNotFound = false;

    this.apiService
      .post(`/auth/verification/qrcode`, { qrCodeType: this.qrCodeType?.toLocaleUpperCase(), applicationId: this.applicationId })
      .pipe(
        finalize(() => {

        })
      )
      .subscribe(
        (response) => {

          if (response.data && response.success) {
            this.details = response.data;

            if (Object.values(this.details).length < 1) {
              this.searchedDataNotFound = true;
            }
          }
          else {
            this.errorLoadingDetails = true;

          }

        },
        (error) => {
          this.errorLoadingDetails = true;
          console.error('Error loading category questions', error);
        }
      );
  }

}


